import React from "react";
import * as Globals from '../modules/Globals';
import CBCard from "../components/CBCard";
import useLanguage from '../hooks/uselanguage';
import TitleHeader from "../components/TitleHeader";

const Musica = () => {
    const lang = (useLanguage().language === 'pt')?1:2;

    //var cont = 1;

    return (
        <>
            <TitleHeader />
            {
            Globals.tdata.musica.map(
                item => {
                    if( lang === item.lang )
                        return (
                            <CBCard 
                                title={item.titulo}
                                descr={item.descr}
                                img={item.imagem}
                                /*reverse={(cont++%2)===0}*/
                            />
                        )
                }
            )
            }
        </>
    );
};

export default Musica;